<oph-back-button (buttonClick)="back.emit()"></oph-back-button>

<h1>Assign People to Task</h1>

<div class="button-group-container">
  <oph-button-group
    class="boolean-button-group"
    [options]="options"
    [selectedOptionName]="selectedOption"
    [style]="{height: '36px'}"
    [buttonStyle]="{padding: '0px 10px', fontSize: '15px'}"
    (optionClick)="selectedOption = $any($event)"
  ></oph-button-group>
</div>

@if ({selectedRequirements: selectedRequirements$ | async, combinedUsers: combinedUsers$ | async}; as state) {
  <div class="item-container-wrapper oph-scroll-bar">
    <div class="item-container">
      @if (selectedOption === 'people') {
        @if (state.combinedUsers?.length > 0) {
          @for (user of state.combinedUsers; track user) {
            <task-dialog-requirement-item
              [display]="user.username"
              [selected]="usersControl.value?.includes(user._id)"
              [user]="user"
              type="people"
              (buttonClick)="onOption($event, user._id, 'users')"
            ></task-dialog-requirement-item>
          }
        } @else {
          <div class="no-people-container">
            <p>There are no people assigned to this project.</p>
          </div>
        }
        <div class="add-people-button-container">
          <button class="add-people-button" (click)="onAddPeople()">Manage Project Members</button>
        </div>
      }
      @if (selectedOption === 'teams') {
        @for (team of filteredTeams$ | async; track team) {
          <task-dialog-requirement-item
            [display]="team.name"
            [selected]="teamsControl.value?.includes(team.id)"
            type="teams"
            (buttonClick)="onOption($event, team.id, 'teams')"
          ></task-dialog-requirement-item>
        }
      }
      @if (selectedOption === 'skills') {
        @for (skill of requirements$ | async; track skill) {
          <task-dialog-requirement-item
            [display]="skill.name"
            [selected]="skillsControl.value?.includes(skill._id)"
            type="skills"
            (buttonClick)="onOption($event, skill._id, 'skills')"
          ></task-dialog-requirement-item>
        }
      }
    </div>
  </div>
}
